import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"
import { useToast } from "./use-toast"
import TickSvg from "./TickSymbol/TickSvg";

export function Toaster() {
  const { toasts } = useToast()

  return (
    (<ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        if (props && props.variant === 'payment_complete') {
          return (
            (<Toast key={id} {...props}>
              <div className="flex flex-col w-full h-full justify-center items-center gap-[5vw] lg:gap-[3vw]">
                <img style={{objectPosition:"50% 30%"}} className="absolute z-[-1] object-cover w-[50vh] h-[50vh] lg:w-[30vw] lg:h-[30vw] rounded-[20px]" src="https://static.wixstatic.com/media/da937f_630ed7c2f1be4e3aa5d2c0c691e2b4cc~mv2.webp" />
              {/* <p className="text-[5vw] lg:text-[1.5vw] text-white">Booking Complete !</p> */}
              <div className="w-full min-h-[10%] flex flex-col justify-center items-center fixed bottom-0 mb-[3vh] lg:mb-[1vw]">         
                <div className="hidden lg:flex">
                <TickSvg width={"2vw"} height={"2vw"} strokeColor={"#e65439"} />
                </div>  
                <div className="flex lg:hidden">
                <TickSvg width={"4vh"} height={"4vh"} strokeColor={"#e65439"} />
                </div>     
                <p className="m-0 text-[2.5vh] lg:text-[1.7vw]">THANK YOU!</p>
                <p className="m-0 text-[1.8vh] lg:text-[1.2vw]">We have recieved your enquiry</p>
                <p className="w-[60%] text-center text-[1.3vh] m-0 lg:text-[0.8vw]">One of our team members will get in touch within the next 12-24 hours.</p>
              </div>
              
              </div>
              {action}
              <ToastClose />
            </Toast>)
          )
        } else {
          return (
            (<Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>)
          );
        }
      })}
      <ToastViewport />
    </ToastProvider>)
  );
}
